import {
    watchGetCoupon
} from "api/modules/Plans/modules/sagas";
import {
    watchCompleteVerification,
    watchLoginFailure,
    watchLoginRequest,
    watchLogout,
    watchRenewSession,
    watchResendVerificationEmail,
    watchUnlink
} from "auth";
import { all, fork } from "redux-saga/effects";
import { State } from "redux/state";
import {
    watchAcceptInvite,
    watchAddPaymentAccount,
    watchAddPublishingAccount,
    watchAddUserToOrganization,
    watchCreateOrganization,
    watchDeletePendingUser,
    watchFetchAvailableAppsSummary,
    watchFetchOrganization,
    watchFetchOrganizationList,
    watchFetchOrganizationUserAnalytics,
    watchFetchPaymentAccountSummary,
    watchFetchUsersOfOrganization,
    watchRemoveUserFromOrganization,
    watchUpdateOrganization,
    watchUpdateUserRoles,
    watchUploadOrgIcon
} from "routes/Organization/modules/sagas";


export function injectSaga(store: AsyncStore<State>, sagas: any[]) {
    // We had a HUGE bug where on every route change we could inject more sagas, which means we added more action watchers
    // which means we would keep making more network requests....
    // It was fixed with the help from this comment: https://github.com/react-boilerplate/react-boilerplate/issues/1434#issuecomment-310783513
    const asyncSagas = store.asyncSagas;
    const filteredSagas = sagas.filter(saga => !(asyncSagas.has(saga) && asyncSagas.get(saga).isRunning()));
    filteredSagas.forEach(saga => asyncSagas.set(saga, store.runSaga(saga)));
}

export function* rootSaga() {
    yield all([
        fork(watchAcceptInvite),
        fork(watchAddPaymentAccount),
        fork(watchAddPublishingAccount),
        fork(watchAddUserToOrganization),
        fork(watchCreateOrganization),
        fork(watchDeletePendingUser),
        fork(watchFetchAvailableAppsSummary),
        fork(watchFetchOrganization),
        fork(watchFetchOrganizationList),
        fork(watchFetchOrganizationUserAnalytics),
        fork(watchFetchPaymentAccountSummary),
        fork(watchFetchUsersOfOrganization),
        fork(watchRemoveUserFromOrganization),
        fork(watchUpdateOrganization),
        fork(watchUpdateUserRoles),
        fork(watchUploadOrgIcon),
        fork(watchLoginRequest),
        fork(watchLoginFailure),
        fork(watchLogout),
        fork(watchUnlink),
        fork(watchCompleteVerification),
        fork(watchRenewSession),
        fork(watchResendVerificationEmail),
        fork(watchGetCoupon)
    ]);
}
